<section class="version-modal">
    <ng-container>
      <header class="header">
        <div class="header-wrapper">
            <h1 class="header-title">{{'SHARED.VERSION_MODAL.title' | translate}}</h1>
            <p>{{'SHARED.VERSION_MODAL.description' | translate}}</p>
        </div>
        <button [attr.aria-label]="'SHARED.VERSION_MODAL.closeAria' | translate" (click)="onCancelClick()" class="close-btn">
          <svg-icon class="close-btn-icon" src="assets/images/close_mobile_.svg"></svg-icon>
        </button>
      </header>
      <main class="main">

        <div class="nav-btns">
          <ic-ghost-button
          [typeHTML]="'button'"
          appPreventDoubleClick
          (throttledClick)="onConfirmClick()"
          [type]="GhostButtonType.BIG_FIRST_RANK_FLEX"
          [showArrow]="false"
          [justifyContent]="'center'"
          [width]="140">
          <span
            class="forwardSpan start-btn__label"
            [innerHtml]="'SHARED.VERSION_MODAL.reloadButton' | translate"></span>
          </ic-ghost-button>

          <ic-ghost-button
          [typeHTML]="'button'"
          (click)="onCancelClick()"
          [type]="GhostButtonType.BIG_SECOND_RANK_FLEX"
          [showArrow]="false"
          [justifyContent]="'center'"
          [width]="140">
          <span class="forwardSpan start-btn__label" [innerHtml]="'SHARED.VERSION_MODAL.cancelButton' | translate"></span>
          </ic-ghost-button>
        </div>
      </main>
    </ng-container>
  </section>
  